import { Box, Button } from '@mui/material';
import { observer } from 'mobx-react';
import { forwardRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Controller, useFormContext } from 'react-hook-form';
import ChangeMainContactModal from './UpdateMainContactModal';
import MainContactCard from './MainContactCard';
import IconLibrary from '../../IconLibrary';

/*
Data Format
{
  id:
  recordVersion
  user:{
    id:
    firstName
    lastName
    email
    phoneNumber
  }
}
*/
const ServiceProviderMainContact = forwardRef((props, ref) => {
  const { getValues, control } = useFormContext();
  const serviceProviderId = getValues('serviceProviderId');
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const currentValue = getValues(props?.name);

  // form permission inject from field generator
  const showChangeButton = props?.permission === 'WRITE';

  return (
    <Controller
      name={props?.name}
      control={control}
      render={({ field }) => {
        const { value } = field;
        const readOnlyUser = value?.user || value;
        return (
          <Box ref={ref}>
            {readOnlyUser && (
              <Box>
                <MainContactCard user={readOnlyUser} />
              </Box>
            )}
            {showChangeButton && (
              <Button
                sx={{ mt: 2 }}
                size="small"
                startIcon={<IconLibrary.User />}
                variant="contained"
                onClick={() => setOpenUpdateModal(true)}>
                {props?.field?.action === 'NEW' ? (
                  <FormattedMessage
                    id="SELECT_MAIN_CONTACT"
                    defaultMessage="Select Main Contact"
                  />
                ) : (
                  <FormattedMessage
                    id="CHANGE_MAIN_CONTACT"
                    defaultMessage="Change Main Contact"
                  />
                )}
              </Button>
            )}
            {showChangeButton && (
              <ChangeMainContactModal
                open={openUpdateModal}
                onClose={() => {
                  setOpenUpdateModal(false);
                }}
                serviceProviderId={serviceProviderId}
                setOpenModal={setOpenUpdateModal}
                action={props?.field?.action}
                onChange={updatedValue => {
                  const newValue = {
                    id: currentValue?.id,
                    recordVersion: currentValue?.recordVersion,
                    user: {
                      id: updatedValue?.id,
                      firstName: updatedValue?.firstName,
                      lastName: updatedValue?.lastName,
                      email: updatedValue?.email,
                      phoneNumber: updatedValue?.phoneNumber,
                    },
                  };
                  field.onChange(newValue);
                }}
              />
            )}
          </Box>
        );
      }}
    />
  );
});

export default observer(ServiceProviderMainContact);
